import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconEmail3"><Path d="M22 7.40197V6.75C22 5.23122 20.7688 4 19.25 4H4.75C3.23122 4 2 5.23122 2 6.75V7.40197C4.57249 9.93619 8.10362 11.5 12 11.5C15.8964 11.5 19.4275 9.93619 22 7.40197Z" fill="currentColor"/><Path d="M22 9.4187C19.2802 11.6564 15.797 13 12 13C8.20301 13 4.71984 11.6564 2 9.4187V17.25C2 18.7688 3.23122 20 4.75 20H19.25C20.7688 20 22 18.7688 22 17.25V9.4187Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail3;
